/*
  Promo expiry sweep.

  Liquid already refuses to render an expired promo, but that decision is baked
  into the HTML at render time and Shopify can serve that HTML from its page
  cache for a while afterwards. So a promo that ended two minutes ago can still
  be sitting in a cached page. This re-checks the deadline in the visitor's
  browser, where there is no cache to go stale, and takes the promo down.

  Markup contract - an element carries:
    data-promo-expires-at="1790827199"   absolute Unix seconds, from
                                         snippets/promo-expiry-stamp.liquid
    data-promo-expired-action="hide"     remove it from the layout (default), or
                            ="conceal"   keep its box but make it invisible, for
                                         a badge whose height other cards in the
                                         row are reserving to keep titles level
    data-promo-pill-releases="<sel>"     optional: elements matching <sel> were
                                         standing by behind this promo. Their
                                         data-savings-pill-deferred flag is cleared
                                         so whoever owns them can take the slot back

  A missing or zero timestamp means no expiry was set, and is always left alone.
  Nothing here renders a visible countdown - the deadline is only ever compared
  against, never displayed.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-promo-expires-at]';

  function expire(node) {
    if (node.getAttribute('data-promo-expired-action') === 'conceal') {
      // Matches .rezy-promo-badge-spacer: the box stays, so the heading below it
      // does not jump up while sibling cards still show their badge.
      node.style.visibility = 'hidden';
      node.setAttribute('aria-hidden', 'true');
    } else {
      node.hidden = true;
      node.style.display = 'none';
    }
    node.setAttribute('data-promo-expiry-done', '');

    // Anything that was standing by behind this promo is now free to show. We only
    // drop the flag; the owning script decides whether the element actually belongs
    // on screen, because only it knows the current numbers.
    var releases = node.getAttribute('data-promo-pill-releases');
    if (releases) {
      var waiting = document.querySelectorAll(releases);
      for (var i = 0; i < waiting.length; i++) {
        waiting[i].removeAttribute('data-savings-pill-deferred');
      }
      document.dispatchEvent(new CustomEvent('rz:promo-expired', { detail: { node: node } }));
    }
  }

  function sweep() {
    var nodes = document.querySelectorAll(SELECTOR);
    var pending = 0;
    var now = Date.now() / 1000;

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.hasAttribute('data-promo-expiry-done')) continue;

      // Number() rather than parseInt: an empty or malformed attribute yields NaN
      // instead of a partial number, and NaN falls through to "leave it alone".
      var endsAt = Number(node.getAttribute('data-promo-expires-at'));
      if (!endsAt || isNaN(endsAt)) continue;

      if (now >= endsAt) expire(node);
      else pending++;
    }
    return pending;
  }

  function start() {
    if (!sweep()) return;
    // Something on the page is still live. Check each minute so a promo that runs
    // out while the page sits open comes down without a reload; a minute is close
    // enough for a promo deadline and costs nothing.
    var timer = setInterval(function () {
      if (!sweep()) clearInterval(timer);
    }, 60000);
    // A laptop waking from sleep fires this long before the next interval tick.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sweep();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // Theme editor re-renders sections in place, and the configurator swaps its
  // price block on every configuration change - both hand us fresh nodes.
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('rz:promo-expiry-refresh', start);
})();
